@if (tournamentId !== null && data !== null) {
<div class="row px-3 px-lg-0">
    <div class="col-12 col-sm-6">
        <select class="custom-select border-light2 mb-1" [(ngModel)]="seasonId" (change)="onSeasonChange($event)">
            @for (s of data.seasons; track $index) {
            <option [value]="s.season.id">
                {{ s.season.name }}
            </option>
            }
        </select>
    </div>
    <div class="col-12 col-sm-6">
        <select
            class="custom-select border-light2 mb-1"
            [(ngModel)]="subtournamentId"
            (change)="onSubtournamentChange($event)"
        >
            @for (s of selectedSeason?.subtournaments; track $index) {
            <option [value]="s.id">
                {{ s.name }}
            </option>
            }
        </select>
    </div>
</div>
<h4 class="head mt-3 ml-2 ml-xl-0">{{ 'web.faceoffs' | translate }} {{ seasonName }}, {{ subtournamentName }}</h4>
<app-faceoffs [sportId]="sportId" [sportName]="sportName" [participantFaceoffs]="data"> </app-faceoffs>
} @else {
<app-placeholder-table></app-placeholder-table>
}
